export const stepBridgingPage =
  'Log in, create an account or continue as guest';
export const stepPersonalDetailsPage = 'Enter personal details';
export const stepSuspensionDetailsPage = 'Suspension letter';
export const stepDeclarationPage = 'Declaration details';
export const stepReviewAndSubmitPage = 'Review application and submit';
export const stepGoodBehaviourPage = 'Good behaviour application complete';
export const stepErrorPage = 'Error';
